export function getAudioPermission(callback) {
  // navigator.mediaDevices.getUserMedia(
  //   { audio: true },
  //   () => {
  //     console.log("Permission Granted");
  //   },
  //   () => {
  //     console.log("Permission Denied");
  //   }
  // );
  navigator.mediaDevices
    .getUserMedia({ audio: true })
    .then(() => {
      callback && callback();
    })
    .catch(() => {
      console.log("Permission Denied");
    });
}
